import { useContext } from 'react'

import { Button, Tooltip } from '@mui/material'

import { StudioSidebarContext } from './studio-sidebar'

const SidebarAction = ({ label, icon, active = false, disabled = false, onClick }) => {
  const { collapsed } = useContext(StudioSidebarContext)

  return (
    <Tooltip
      title={collapsed ? label : ''}
      placement="right"
      slotProps={{ tooltip: { sx: theme => ({ backgroundColor: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black, color: theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white }) } }}
    >
      <Button
        onClick={onClick}
        disabled={disabled}
        aria-label={label}
        startIcon={collapsed ? undefined : icon}
        sx={{
          minWidth: collapsed ? 64 : undefined,
          justifyContent: collapsed ? 'center' : 'flex-start',
          px: collapsed ? 1 : 2,
          color: active ? 'primary.main' : 'text.secondary',
          '& .MuiButton-startIcon': {
            width: 32,
            marginLeft: 0,
            marginRight: 0,
            justifyContent: 'flex-start'
          },
          '&.Mui-disabled': { color: 'action.disabled' }
        }}
      >
        {collapsed ? icon : label}
      </Button>
    </Tooltip>
  )
}

export default SidebarAction
